import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b4f5c98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-grid" }

import TicketPresentationCard from "@/components/blocks/TicketPresentationCard.vue";
import ContentWrapper from "@/components/generics/ContentWrapper.vue";
import { useBookingStore } from "@/store/bookingStore";
import { reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketPresentationView',
  setup(__props) {

const bookingStore = useBookingStore();

const state = reactive({
  currentActiveTicket: "",
});

function handleClick(id: string) {
  state.currentActiveTicket = id;
}

const ticket_images = [
  "background-florence",
  "background-london",
  "background-prague",
  "background-aqueduct",
  "background-barcelona",
  "background-louvre",
  "background-eifel",
  "background-vernazza",
  "background-railway-italy",
  "background-champs",
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentWrapper, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookingStore).availableTickets, (ticket, index) => {
          return (_openBlock(), _createBlock(TicketPresentationCard, {
            key: `${ticket.id}-${index}-ticket`,
            ticket: ticket,
            "is-open": ticket.id != state.currentActiveTicket,
            onClicked: handleClick,
            "background-img-class": [...ticket_images, ...ticket_images][index]
          }, null, 8, ["ticket", "is-open", "background-img-class"]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})